import React from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import tinycolor from 'tinycolor2'
import { GridViewGlyph16Icon, ListViewGlyph16Icon } from 'assets/icons'
import uiConstants from 'config/constants/ui'
import { useGlobalState } from 'src/sites/state'

// For now this component has 2 button options (list and grid)
// But presumeably, we might add buttons for lots of different
// kinds of views such as: masonry, mixed, featured, column
// We also may eventually make this a filter and sort control as well
// and options will be available in a drop-down menu
const ViewModeSwitchControl = ({
   onGridButtonClick,
   onListButtonClick,
   currentViewMode
}) => {
   const { theme } = useGlobalState()
   const iconColor = tinycolor(theme.tmpTitleColor).setAlpha(0.5).toRgbString()
   const activeIconBackgroundColor = tinycolor(theme.tmpTitleColor).setAlpha(0.1).toRgbString()

   return (
      <>
         <View
            onClick={onListButtonClick}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="30px"
            height="30px"
            backgroundColor={currentViewMode === uiConstants.viewModes.ROW &&
               activeIconBackgroundColor
            }
            borderRadius="50%"
            style={{ cursor: 'pointer' }}>
            <ListViewGlyph16Icon
               color={iconColor}
               width="12px"
               height="12px"
            />
         </View>
         <View
            onClick={onGridButtonClick}
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="30px"
            height="30px"
            marginLeft="10px"
            backgroundColor={currentViewMode === uiConstants.viewModes.GRID &&
               activeIconBackgroundColor
            }
            borderRadius="50%"
            style={{ cursor: 'pointer' }}>
            <GridViewGlyph16Icon
               color={iconColor}
               width="12px"
               height="12px"
            />
         </View>
      </>
   )
}

ViewModeSwitchControl.propTypes = {
   onGridButtonClick: PropTypes.func.isRequired,
   onListButtonClick: PropTypes.func.isRequired,
   currentViewMode: PropTypes.oneOf([
      uiConstants.viewModes.GRID,
      uiConstants.viewModes.ROW
   ]).isRequired
}

export default ViewModeSwitchControl
